/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { doRefreshToken, doClearTokens, getAccessToken, getIsRefreshing } from 'src/reducers/reducer_core'

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve(token)
        }
    })

    failedQueue = []
}

export default (store) => {
    // Request interceptor - Add access token to headers
    axios.interceptors.request.use(
        async (request) => {
            request.withCredentials = true

            // Add Authorization header with access token if available
            const state = store.getState()
            const accessToken = getAccessToken(state)

            if (accessToken && !request.headers.Authorization) {
                request.headers.Authorization = `Bearer ${accessToken}`
            }

            return request
        },
        (error) => {
            return Promise.reject(error)
        }
    )

    // Response interceptor - Handle 401 errors and refresh token
    axios.interceptors.response.use(
        function (response) {
            return response
        },
        async function (error) {
            const originalRequest = error.config

            if (error.response) {
                // Check if it's a 401 error and not already retried
                if ((error.response.status === 401 || error?.response?.data?.code === 401) && !originalRequest._retry) {
                    // Skip token refresh for login, register, and refresh-token endpoints
                    if (originalRequest.url?.includes('/auth/login') ||
                        originalRequest.url?.includes('/auth/register') ||
                        originalRequest.url?.includes('/auth/refresh-token')) {
                        return Promise.reject(error)
                    }

                    if (isRefreshing) {
                        // If already refreshing, queue this request
                        return new Promise(function(resolve, reject) {
                            failedQueue.push({ resolve, reject })
                        }).then(token => {
                            originalRequest.headers.Authorization = `Bearer ${token}`
                            return axios(originalRequest)
                        }).catch(err => {
                            return Promise.reject(err)
                        })
                    }

                    originalRequest._retry = true
                    isRefreshing = true

                    return new Promise(function(resolve, reject) {
                        store.dispatch(doRefreshToken())
                            .then((response) => {
                                const newAccessToken = response?.data?.accessToken || response?.accessToken

                                if (newAccessToken) {
                                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
                                    processQueue(null, newAccessToken)
                                    resolve(axios(originalRequest))
                                } else {
                                    processQueue(error, null)
                                    store.dispatch(doClearTokens())
                                    reject(error)
                                }
                            })
                            .catch((err) => {
                                processQueue(err, null)
                                store.dispatch(doClearTokens())
                                // Optionally redirect to login
                                // window.location.href = '/login'
                                reject(err)
                            })
                            .finally(() => {
                                isRefreshing = false
                            })
                    })
                }
            }

            return Promise.reject(error)
        },
    )
}
